var render = function (_h,_vm) {var _c=_vm._c;return _c('carousel',{attrs:{"per-page":1,"loop":true,"pagination-padding":6,"pagination-size":6,"pagination-active-color":'#F66B9C',"pagination-color":'#D7DADD',"resistance-coef":10,"navigationEnabled":true}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }